import React from 'react';
import { t } from 'Locale';
import { Platform } from 'react-native';
import { popUpDefaultProps, popUpPropTypes } from './propTypes';

const UsedPopup = Platform.select({
    native: () => require('./components/PopUpNative').default,
    web: () => require('./components/PopUpDefault').default
});

const PopUp = (props) => {
    const { visible, confirmLabel } = props;
    if (!visible) return null;
    const modifiedProps = {
        ...props,
        confirmLabel: confirmLabel || t('COMMON.OK')
    };

    return <UsedPopup {...modifiedProps} />;
};

PopUp.defaultProps = popUpDefaultProps;

PopUp.propTypes = popUpPropTypes;

export default PopUp;
